<template>
  <div id="form-name-and-description">
    <Input
      class="scs-input"
      heading="Form Name"
      placeholder="Form Name"
      :initialValue="form.name"
      :error="errors.name"
      @scs-input="nameInput"
    />
    <TextArea
      class="scs-input scs-text-area"
      heading="Form Description"
      placeholder="Description"
      :initialValue="form.description"
      @scs-input="descriptionInput"
    />
    <Toggle
      heading="Enable Spotify Playlists"
      :option1="true"
      :option2="false"
      :selected="form.streamingEnabled"
      :formatter="formatter"
      @toggle="streamingEnabledInput"
    />
  </div>
</template>
<script>
import Input from "@/Components/Elements/Input.vue";
import TextArea from "@/Components/Elements/TextArea.vue";
import Toggle from "@/Components/Elements/Binary.vue";
export default {
  methods: {
    nameInput(value) {
      this.$emit("name-input", value);
    },
    descriptionInput(value) {
      this.$emit("description-input", value);
    },
    streamingEnabledInput(value) {
      this.$emit("streaming-enabled-input", value);
    },
    formatter(val) {
      if (val === true) {
        return "Yes";
      }
      if (val === false) {
        return "No";
      }
    },
  },
  components: {
    Input,
    TextArea,
    Toggle,
  },
  emits: ["name-input", "description-input", "streaming-enabled-input"],
  props: ["form", "errors"],
};
</script>
<style scoped>
@media screen {
  #form-name-and-description {
    height: 350px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 30px;
  }

  .scs-input {
    margin: 10px;
  }

  .scs-text-area > textarea {
    height: 200px;
  }
  @media (min-width: 800px) {
    .scs-input {
      width: 350px;
    }
  }
}

@media screen {
  @media (min-width: 800px) {
  }
}
</style>
